import React from 'react';

interface Props {
  nomeArquivo: string;
  excluindo: boolean;
  onCancelar: () => void;
  onConfirmar: () => void;
}

// Épico "Mensagens, Feedbacks e Gestão de Arquivos", seção 27 — confirmação obrigatória antes
// da exclusão. A decisão de PERMITIR a exclusão é sempre do backend (CA24) — este modal só
// aparece quando `arquivo.permissions.canDelete` já veio `true` da API (ver AuditFileItem).
const AuditDeleteFileModal: React.FC<Props> = ({ nomeArquivo, excluindo, onCancelar, onConfirmar }) => {
  return (
    <div className='audit-modal-backdrop' onClick={excluindo ? undefined : onCancelar}>
      <div className='audit-modal audit-modal-sm' onClick={(e) => e.stopPropagation()} role='dialog' aria-modal='true'>
        <div className='audit-modal-header'>
          <h4>Excluir arquivo</h4>
          {!excluindo && <button type='button' className='btn-close' aria-label='Fechar' onClick={onCancelar} />}
        </div>
        <div className='audit-modal-body'>
          <p>
            Tem certeza de que deseja excluir o arquivo <strong>{nomeArquivo}</strong>?
          </p>
        </div>
        <div className='audit-modal-footer'>
          <button type='button' className='btn btn-sm btn-light' disabled={excluindo} onClick={onCancelar}>
            Cancelar
          </button>
          <button type='button' className='btn btn-sm btn-danger' disabled={excluindo} onClick={onConfirmar}>
            {excluindo && <span className='spinner-border spinner-border-sm me-2' />}
            Confirmar Exclusão
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuditDeleteFileModal;
